export interface StateUser {
  sessionId: string;
  userStatusLogout: UserStatusLogout;
  webId: string;
}

export enum UserStatusLogout {
  initial,
  loading,
  success,
  fail,
}
